module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "card card-indent mt-2"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row bg-primary-light"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "text-weight-normal mb-2"
  }, [_vm._v(_vm._s(_vm.labels.HEADING))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('p'), (_vm.formSubmitted && (!_vm.formValid || _vm.loginFailed || _vm.user601)) ? _c('div', {
    staticClass: "feedback",
    attrs: {
      "id": "feedbackPanel"
    }
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [(!_vm.loginFilled) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("                        \n                        " + _vm._s(_vm.labels.LOGIN_FIELD_REQUIRED) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (!_vm.passwordFilled) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                        " + _vm._s(_vm.labels.PASSWORD_FIELD_REQUIRED) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.loginFailed) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                        " + _vm._s(_vm.labels.LOGIN_FAIL) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (!_vm.loginValid || _vm.user601) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                        " + _vm._s(_vm.labels.CHANGE_DENIED_TEXT) + "\n                      ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "id": "id1",
      "method": "post",
      "name": "CredentialsForm",
      "action": ""
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "j_username"
    }
  }, [_vm._v(_vm._s(_vm.labels.USER))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.UserName),
      expression: "credentials.UserName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "login",
      "type": "text",
      "value": "",
      "name": "login",
      "maxlength": "300"
    },
    domProps: {
      "value": (_vm.credentials.UserName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.UserName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.labels.PASSWORD))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.Password),
      expression: "credentials.Password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "size": "15",
      "value": "",
      "name": "password",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.credentials.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.Password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('center', [_c('pulse-loader', {
    attrs: {
      "loading": _vm.showSpinner,
      "color": "#aab0b3"
    }
  })], 1), _vm._v(" "), (!_vm.showSpinner) ? _c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "name": "loginButton",
      "id": "id2"
    },
    on: {
      "click": _vm.proceed
    }
  }, [_vm._v(_vm._s(_vm.labels.LOGIN))]) : _vm._e()], 1), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "not-implemented",
    attrs: {
      "href": "#",
      "title": "Forgot Password"
    },
    on: {
      "click": _vm.forgotPassword
    }
  }, [_vm._v(_vm._s(_vm.labels.FORGOT_PASSWORD))])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "not-implemented",
    attrs: {
      "href": "#",
      "title": "Sign in with a different account"
    }
  }, [_vm._v(_vm._s(_vm.labels.DIFFERENT_ACCOUNT))])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center text-gray-light my-4"
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-72 mmk-icon-account",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "0px",
      "height": "0px",
      "position": "absolute",
      "left": "-100px",
      "top": "-100px",
      "overflow": "hidden"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "id1_hf_0",
      "id": "id1_hf_0"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77fd09d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
// module id = 184
// module chunks = 1